<template>
  <v-dialog
    v-model="showUnitModal"
    :scrollable="true"
    max-width="900px "
    persistent
  >
    <v-card>
      <v-card-title>
        <span class="headline">
          <v-icon class="mr-2">fa fa-book</v-icon>
          {{ title.title }}
        </span>
      </v-card-title>
      <v-card-text>
        <div class="kt-portlet__head-group d-flex flex-wrap justify-end">
          <v-btn
            color="primary"
            dark
            depressed
            @click="exportData()"
            text
            class="mt-3 mt-md-0 mx-1"
          >
            <v-icon left>fal fa-file-export</v-icon>
            Export Data
          </v-btn>

          <v-snackbar :timeout="0" v-model="warningDialog">
            Progress Report is exporting. Please wait!
            <v-progress-circular
              :size="20"
              class="mx-5"
              color="white"
              indeterminate
            ></v-progress-circular>
          </v-snackbar>
        </div>
        <v-container>
          <v-row>
            <v-data-table
              :headers="headers"
              :items="units"
              :single-expand="singleExpand"
              :expanded.sync="expanded"
              :show-expand="params.isCompleted"
              class="elevation-1 unit-modal__table"
            >
              <template
                v-if="params.isCompleted"
                v-slot:item.data-table-expand="{ item, expand, isExpanded }"
              >
                <v-icon
                  :disabled="item.notes.length < 1"
                  v-if="!isExpanded"
                  @click="expand(!isExpanded)"
                >
                  fa fa-caret-down
                </v-icon>
                <v-icon v-if="isExpanded" @click="expand(!isExpanded)">
                  fa fa-caret-up
                </v-icon>
              </template>
              <template
                v-if="params.isCompleted"
                v-slot:expanded-item="{ headers, item }"
              >
                <td :colspan="headers.length">
                  <p class="ma-3 h6">Notes:</p>
                  <br />
                  <v-card
                    class="ma-3 pa-3 note-card"
                    v-for="(note, index) in item.notes"
                    :key="index"
                  >
                    <p class="text-left">
                      {{ note.created_at | displayDateTime }}
                    </p>
                    <p class="text-center body-2" v-html="note.value"></p>
                  </v-card>
                </td>
              </template>
              <template #item.name="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      target="_blank"
                      color="primary"
                      text
                      v-bind="attrs"
                      v-on="on"
                      @click="gotoUnitPage(item.id)"
                    >
                      {{ item.name }}
                    </v-btn>
                  </template>
                  <span>View</span>
                </v-tooltip>
              </template>
              <template v-slot:item.due_date="{ item }">
                {{ formatDate(item.due_date) }}
              </template>
              <template v-slot:item.date_completed="{ item }">
                {{ formatDate(item.date_completed) }}
              </template>
            </v-data-table>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue-grey" dark @click="close()"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import dayjs from 'dayjs';

export default {
  name: 'UnitModal',

  props: ['value', 'units', 'title', 'params', 'userId'],

  data() {
    return {
      expanded: [],
      warningDialog: false,
      singleExpand: false,
      headers: [
        {
          text: 'Name',
          tooltip: 'Name of Units',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'From Module',
          align: 'center',
          sortable: true,
          value: 'module_name',
        },
        {
          text: 'Finished Video',
          align: 'center',
          sortable: true,
          value: 'finished_video',
        },
        {
          text: 'Due Date',
          align: 'center',
          sortable: true,
          value: 'due_date',
        },
        {
          text: 'Date Completed',
          align: 'center',
          sortable: true,
          value: 'date_completed',
        },
        {
          text: 'No. Watched',
          align: 'center',
          sortable: true,
          value: 'num_watched',
        },
      ],
    };
  },

  computed: {
    showUnitModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$parent.params.isPlaylist = false;
        this.$parent.params.isCompleted = false;
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    if (this.params.isPlaylist) {
      this.headers[1].text = 'From Playlist';
      this.headers[1].value = 'playlist_name';
    }

    if (this.params.isCompleted) {
      this.renderCompletedHeader();
    }
  },
  methods: {
    renderCompletedHeader() {
      let addHeader = [
        {
          text: 'Quiz Score',
          align: 'center',
          sortable: true,
          value: 'quiz_score',
        },
        {
          text: 'Notes',
          value: 'data-table-expand',
        },
      ];
      this.headers = this.headers.concat(addHeader);
    },
    formatDate(date) {
      if (!date) return 'N/A';
      return dayjs(date).format('MMM D, YYYY, h:mm a');
    },
    gotoUnitPage(id) {
      let routeData = this.$router.resolve({
        name: 'UnitPage',
        params: { id: id },
      });
      window.open(routeData.href, '_blank');
    },
    close() {
      this.showUnitModal = false;
      this.$http.delete('/client/reports/lms/progress/show/destroy-cache/', {
        params: {
          id: this.userId,
          value: this.title.value,
        },
      });
    },
    exportData() {
      this.warningDialog = true;
      this.$http
        .get('/client/reports/lms/progress/show/export-cache/', {
          params: {
            id: this.userId,
            value: this.title.value,
          },
        })
        .then((data) => {
          window.location.assign(data.data);
          setTimeout(() => {
            this.warningDialog = false;
          }, 5000);
        });
    },
  },
};
</script>
<style lang="stylus">
.unit-modal__table
  width 100%
.fa-chevron-down
  font-size 16px !important;

.v-data-table__expanded.v-data-table__expanded__content {
  box-shadow: none !important;
}

.note-card
  width clamp(1rem, 75vw, 60rem);
</style>
